// Admin API client — /admin/system/* (mirrors the API's system aggregate).

import type { AdminSystemMetrics } from '@a7y/types';
import { client } from './transport';

export const systemApi = {
  // System
  getSystemMetrics: () => client.get<AdminSystemMetrics>('/system/metrics'),
  getSystemHealth: () =>
    client.get<{ status: 'healthy' | 'warning' | 'critical'; details?: string }>('/system/health'),
  updateSystemConfig: (data: Record<string, unknown>) =>
    client.post<{ message: string; config: Record<string, unknown> }>('/system/config', data),
};
